module.exports = {
    "Empty": `Tyhj\xe4`
};


//# sourceMappingURL=fi-FI.main.js.map
